exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-wrap[data-v-252a1da2]{width:100%;height:200px;margin:8px 0 4px;padding:10px;box-sizing:border-box;border:1px solid #c0ccda;border-radius:4px;overflow:auto;gap:10px}.card-footer[data-v-252a1da2]{text-align:right;font-size:14px;line-height:1.5}.card-item[data-v-252a1da2]{display:inline-block;margin:4px;padding:0 4px;border:1px solid #c0ccda;border-radius:4px;font-size:14px;line-height:1.5}.flex-row-center[data-v-252a1da2]{display:flex;justify-content:center;align-items:center}.margin-bottom-10[data-v-252a1da2]{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-252a1da2&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/LuFundCampusShield.vue
// module id = 475
// module chunks = 0